export namespace AuthorizationTranslations {
  export const error = {
    unauthenticatedUser: 'unauthenticatedUser',
    unauthorizedUser: 'unauthorizedUser',
    authorizationCodeRequired: 'authorizationCodeRequired',
  } as const;
}
